import React from "react";
import PathChanger from "../../../components/PagesComponents/Setting/Profile/PathChanger.component";
import { Helmet } from "react-helmet";
import PageHeader from "../../../components/PagesComponents/UniversalComponents/PageHeader.component";

const Body = ({ currentTab, handelCurrentTab, pageDetails }) => {
  return (
    <div
      className="flex-col align-start justify-start g-1 overflow-hide   "
      style={{ height: "calc(90vh - 1rem)" }}
    >
      <Helmet>
        <title>Product cube</title>
      </Helmet>
      <PageHeader />

      <div className="w-full overflow-hide flex-row align-start justify-start g-1 flex-1 ">
        {/* left container */}
        <div
          className=" flex-col align-start justify-between g-1 h-full"
          style={{ width: "18rem" }}
        >
          <div
            className="h-full  w-full flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">
              Horizontal access
            </h4>
            <div className="w-full flex-col-align-start-justify-start g-05">
              {pageDetails?.map(({ title, pathName }, index) => {
                return <PathChanger title={title} pathName={pathName} />;
              })}
            </div>
          </div>
        </div>

        {/* right container */}
        <div className="flex-col align-start justify-start flex-1  scroll-y pr-1 h-full">
          {handelCurrentTab()}
        </div>
      </div>
    </div>
  );
};

export default Body;
